import { apiUnsplash } from './api';
// import mockService from './mocks';
// import { doPost } from '../../utils';

const searchImages = async (payload, isMocking) => {
	const { inputSearchValue, searchPage } = payload;
	let data;
	if (isMocking) {
		// data = await mockService.fetchSettings();
	} else {
		// const save_site_subdomainURL = `${process.env.REACT_APP_BASE_API_URL}
		// /public/adviser/save_site_subdomain2/`;
		// const response = await doPost(save_site_subdomainURL, payload);

		const response = await apiUnsplash.get(
			`/search/photos?query=${inputSearchValue}&per_page=${21}&page=${searchPage}`,
			payload,
		);
		console.log('TCL: searchImage -> response', response);
		data = response.data;
	}

	// console.log('TCL: fetchSettings -> data', data);
	return data;
};

export { searchImages };
